import React from 'react';

function SvgIcContractButton(props) {
  return (
    <svg
      width={149}
      height={149}
      viewBox="0 0 149 149"
      xmlSpace="preserve"
      {...props}
    >
      <defs>
        <linearGradient
          id="ic_contract_button_svg__a"
          x2={1}
          y2={1}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#4df8e0" />
          <stop offset={1} stopColor="#2a7ae2" />
        </linearGradient>
      </defs>
      <path
        data-name="Path 373"
        d="M6 0h137a6 6 0 016 6v137a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6z"
        fill="url(#ic_contract_button_svg__a)"
      />
      <g data-name="Group 494">
        <g data-name="Group 493">
          <path
            data-name="Path 491"
            d="M99.393 29.441h-67.38a1.531 1.531 0 00-1.531 1.531v87.287a1.531 1.531 0 001.531 1.531h67.38a1.531 1.531 0 001.531-1.531V30.972a1.531 1.531 0 00-1.531-1.531zm-1.532 87.287H33.545V32.504h64.316z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 496">
        <g data-name="Group 495">
          <path
            data-name="Path 492"
            d="M73.36 44.754H58.046a1.532 1.532 0 000 3.063h15.313a1.532 1.532 0 100-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 498">
        <g data-name="Group 497">
          <path
            data-name="Path 493"
            d="M53.452 63.131h-9.188a1.532 1.532 0 000 3.063h9.188a1.532 1.532 0 000-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 500">
        <g data-name="Group 499">
          <path
            data-name="Path 494"
            d="M93.267 63.131h-33.69a1.532 1.532 0 000 3.063h33.69a1.532 1.532 0 000-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 502">
        <g data-name="Group 501">
          <path
            data-name="Path 495"
            d="M93.267 69.256H38.138a1.532 1.532 0 100 3.063h55.129a1.532 1.532 0 100-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 504">
        <g data-name="Group 503">
          <path
            data-name="Path 496"
            d="M77.953 75.381H38.138a1.532 1.532 0 100 3.063h39.815a1.532 1.532 0 000-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 506">
        <g data-name="Group 505">
          <path
            data-name="Path 497"
            d="M93.267 75.381h-9.188a1.532 1.532 0 100 3.063h9.188a1.532 1.532 0 000-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 508">
        <g data-name="Group 507">
          <path
            data-name="Path 498"
            d="M93.272 81.507H65.703a1.532 1.532 0 100 3.063h27.569a1.532 1.532 0 100-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 510">
        <g data-name="Group 509">
          <path
            data-name="Path 499"
            d="M59.577 81.507H38.138a1.532 1.532 0 100 3.063h21.439a1.532 1.532 0 100-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 512">
        <g data-name="Group 511">
          <path
            data-name="Path 500"
            d="M93.268 87.632h-6.125a1.532 1.532 0 000 3.063h6.125a1.532 1.532 0 000-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 514">
        <g data-name="Group 513">
          <path
            data-name="Path 501"
            d="M45.795 87.632h-7.657a1.532 1.532 0 100 3.063h7.657a1.532 1.532 0 100-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 516">
        <g data-name="Group 515">
          <path
            data-name="Path 502"
            d="M81.017 87.632h-29.1a1.532 1.532 0 100 3.063h29.1a1.532 1.532 0 000-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 518">
        <g data-name="Group 517">
          <path
            data-name="Path 503"
            d="M91.736 106.008H70.297a1.532 1.532 0 100 3.063h21.439a1.532 1.532 0 100-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 520">
        <g data-name="Group 519">
          <path
            data-name="Path 504"
            d="M79.49 38.629H51.921a1.532 1.532 0 000 3.063H79.49a1.532 1.532 0 100-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 522">
        <g data-name="Group 521">
          <path
            data-name="Path 505"
            d="M120.832 43.223h-4.595a6.126 6.126 0 10-12.251 0v55.128a16.206 16.206 0 004.781 11.54l.262.262a1.531 1.531 0 002.165 0l.262-.262a16.206 16.206 0 004.781-11.54V46.286h3.063v13.782h3.063V44.755a1.531 1.531 0 00-1.531-1.532zm-10.719 63.606a13.131 13.131 0 01-2.975-6.946h5.949a13.132 13.132 0 01-2.975 6.946zm3.063-10.009h-6.125V46.286h6.125zm-6.125-53.6a3.063 3.063 0 016.125 0z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 524">
        <g data-name="Group 523">
          <path
            data-name="Path 506"
            d="M93.268 53.943H74.891a1.532 1.532 0 100 3.063h18.376a1.532 1.532 0 100-3.063z"
            fill="#fff"
          />
        </g>
      </g>
      <g data-name="Group 526">
        <g data-name="Group 525">
          <path
            data-name="Path 507"
            d="M71.828 93.758h-33.69a1.532 1.532 0 000 3.063h33.69a1.532 1.532 0 000-3.063z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgIcContractButton;
